import { FC } from "react";

import DashboardLayout from "layouts/DashboardLayout";

import { FrameContainer } from "uikit";

import useEmployeePayPage from "./useEmployeePayPage";

interface Props {
  className?: string;
}

const EmployeePayPage: FC<Props> = ({ className }) => {
  const { frameId } = useEmployeePayPage();

  return (
    <DashboardLayout className={className}>
      <>
        <FrameContainer id={frameId} />
      </>
    </DashboardLayout>
  );
};

export default EmployeePayPage;
